import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AppProvider } from './context/AppContext';
import './index.css';

import { Amplify } from 'aws-amplify';
import config from './amplify_outputs.json';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

Amplify.configure(config);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Authenticator hideSignUp>
    {({ signOut, user }) => (
      <AppProvider>
        <App />
      </AppProvider>
    )}
  </Authenticator>
);
